export default "__VITE_ASSET__DZC12cyO__"